import { preloadImagesIn } from "../utils";
import MasonryLib from 'masonry-layout';

class masonry {
  constructor(context) {
    context.querySelectorAll('[data-masonry]').forEach(element => {
      preloadImagesIn(element).then(_ => { 
        new MasonryLib( element, {
          percentPosition: true
        });
      });
    });
  }
};

export default masonry;